import React from "react";
import { DesktopOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

const AiAssessmentDifferentDevice: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigateToHome = () => {
    navigate("/", { replace: true });
  };
  return (
    <section className="ai-assessment-different-device-container">
      <div className="ai-assessment-different-device-result-container">
        <Result
          title="Session is already started on another device"
          icon={<DesktopOutlined />}
          subTitle="Please use the same device to continue the assessment."
          extra={
            <Button type="primary" onClick={handleNavigateToHome}>
              Home
            </Button>
          }
        />
      </div>
    </section>
  );
};

export default AiAssessmentDifferentDevice;
